'use client';
import AccountIcon from '@repo/ui/src/components/Icons/AccountIcon';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import { useCustomer } from '@hooks/customer';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { classNames } from '@repo/ui/src/utils/classNames';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import Image from '@repo/ui/src/components/Image';

interface Props {
  dark?: boolean;
  showTextOnSmall?: boolean;
  full?: boolean;
  loggedOutText?: string;
  loggedInLabel?: string;
  className?: string;
}

const UserAvatar = ({
  dark,
  full,
  loggedOutText = 'Log In or Sign Up',
  loggedInLabel = 'My Account',
  showTextOnSmall,
  className,
}: Props) => {
  const { accountsEnabled } = useCurrentUrl();
  const { data } = useCustomer();
  const { push } = useModal(ModalID.login);
  const { t } = useTranslation();

  if (!accountsEnabled) {
    return null;
  }

  return (
    <Button
      as={data && Anchor}
      aria-label={loggedOutText}
      label={data && loggedInLabel}
      link={data && t('accountLink.link', undefined, { default: '/account/order-history' })}
      variant={ButtonVariant.bare}
      size="none"
      full={full}
      onClick={!data ? () => push() : undefined}
      className={classNames(
        dark ? 'text-neutral-700' : 'text-neutral-100',
        'items-center gap-2 tra-text-web-sub-2 hidden sm:flex p-3 cursor-pointer group',
        className,
      )}
    >
      {data?.avatar ? (
        <div
          className={classNames(
            dark && 'bg-warm-300 border border-warm-300 rounded-full',
            'relative w-6 h-6',
          )}
        >
          <Image
            className="rounded-full"
            src={data.avatar}
            alt=""
            role="presentation"
            layout="fill"
          />
        </div>
      ) : (
        <span>
          <AccountIcon className="w-6" />
        </span>
      )}
      {showTextOnSmall && !data && <span className="block">{loggedOutText}</span>}
    </Button>
  );
};

export default UserAvatar;
